// @flow
import { createAction } from 'redux-actions';

export const openAnswerEditor = createAction(
  '@ugc/answer/begin-edit',
  (ugcId: UgcId) => ugcId
);

export type EditAnswerActionPayload = {
  text: string,
  ugc_id: UgcId,
  parent_ugc_id: UgcId,
  subject_id: Id,
  catalog_id: Id,
  locale: string,
  target: string,
  ugc_type: 'Answer',
};

export const editAnswer = createAction(
  '@ugc/answer/edit',
  (payload: EditAnswerActionPayload) => payload
);

export const editAnswerSync = createAction(
  '@ugc/answer/sync',
  (payload: EditAnswerActionPayload) => payload,
  (_, payload: ?EditAnswerActionPayload) => payload
);

export type DeleteAnswerActionPayload = {
  ugc_id: UgcId,
  target: 'Answer' | 'Question',
  parent_ugc_id: UgcId,
};

export const deleteAnswer = createAction(
  '@ugc/answer/delete',
  (payload: DeleteAnswerActionPayload) => payload
);

export const deleteAnswerSync = createAction(
  '@ugc/answer/delete-sync',
  (payload: DeleteAnswerActionPayload) => payload,
  (_, payload: ?DeleteAnswerActionPayload) => payload
);

export const resetView = createAction(
  '@ugc/answer/cancel-edit',
  (ugcId: UgcId) => ugcId
);



// WEBPACK FOOTER //
// ./src/containers/answer-editing/answerEditingActions.js